import { Button, List, ListItem } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import { Message, useMessageGetter } from '@messageformat/react';

const ModalForExtremeSports = ({ ibRef }) => {
  const getMessage = useMessageGetter();
  return (
    <Modal
      ref={ibRef}
      className="competitiveSportsModal"
      shouldCloseOnOverlayClick={true}
      title={<Message id="labelText.competitiveSportsModalItemAdditionalCover" />}
      footer={
        <Button
          compact
          type="button"
          id="infobox-insurance-cancel"
          onClick={() => ibRef.current.close()}
        >
          <Message id={`buttonText.closeButton`} />
        </Button>
      }
    >
      <>
        <h3 className='firstTitle'><Message id="labelText.competitiveSportsModalTitleAviationSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemHotAirBalloonAndGasbagFlight" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemMotorisedFlying" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemHangGlidingAndParagliding" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemMicroLightFlying" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemSkydiving" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemIndoorSkydiving" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemFlyingWithAmateurBuiltAircraft" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemGlidingAndMotorsailing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemParasailing" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleTeamSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemAmericanFootball" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemAustralianFootball" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemRugby" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemlLacrosse" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemRollerDerby" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleCombatSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemMixedMartialArts" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemWrestling" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleClimbingSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemIceAndRockClimbing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemGlacierAndMountainClimbing" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleDivingSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemScubaDiving" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemFreediving" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleWinterSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemSledding" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemFreestyleSkiing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemSpeedAndDownhillSkiing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemOffPisteSkiing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemDownhillSkating" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleStrengthSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemStrengthAthletics" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemPowerlifting" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemWeightlifting" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemBodybuilding" />
          </ListItem>
        </List>

        <h3><Message id="labelText.competitiveSportsModalTitleOtherSeparatelyInsuredSports" /></h3>
        <List border="none" className="removeMargin" size="small">
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemBmxCycling" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemBungeeJumping" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemSkimbatOrKiteSurfing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemSailboardingAndFlyboarding" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemParkour" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemAbseiling" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemAcrobatics" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemFreeRunning" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemDownhillBiking" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemOceanSailing" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemBaseJumping" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemTrekking" />
          </ListItem>
          <ListItem>
            <Message id="labelText.competitiveSportsModalItemWildwaterCanoeing" />
          </ListItem>
        </List>

        <List border="none" className="removeMargin" size="small">
          <ListItem titleElement="h3"
            title={`${getMessage('labelText.competitiveSportsModalTitleOtherSportsOfComparableLevelOfRisk')}`}
          />
        </List>
      </>

    </Modal>
  );
};

export default ModalForExtremeSports;
